import { Component, ViewChild } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { SessionService } from '../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { CommonService } from '../Model/Common/common.service';
import { ComboService } from '../Model/Combo/combo.service';
import { Subject } from 'rxjs';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-employee-termination',
  standalone: true,
  imports: [LoaderComponent, CommonModule, NgSelectModule, FormsModule, DataTablesModule],
  templateUrl: './employee-termination.component.html',
  styleUrl: './employee-termination.component.scss'
})
export class EmployeeTerminationComponent {

  isDisabled: boolean = false;
  dtoptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  constructor(
    private comboload: ComboService,
    public common: CommonService,
    private toast: ToastService,
    private session: SessionService,
    private router: Router
  ) {
    
    this.dtoptions = { ...this.common.commonDToptions };
    this.user = this.session.GetUserDetails();
  }

  ngOnInit() {
    this.ComboLoad('Branch');
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  user: any;
  Branchs: any[] = [];
  Clients: any[] = [];
  Sites: any[] = [];
  TableDatas: any[] = [
    {EmployeeName: 'Reshma', JoiningDate: '27-03-2026', Branch: 'Andheri', Client: 'LIC', Site: 'Marol',
      ProbationEndDate: '27-05-2026', NoticePeriod: '30 Days', Status: 'Probation'
    }
  ]

  Filter = {
    Date: '' as any,
    BranchId: null,
    ClientId: null,
    SiteId: null,
    Code: '',
    EmpCode: '' as any,
    // MonthName: null as any,
    EmployeeId: null as any,
    IsWithdraw: false,
    EmpType: 'FRONT',
    EmpPhoto: '',
    EmpName: '',
    EmpDesignation: '',
    EmpJoiningDate: ''
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    if (Combotype == 'Site') {
      this.Filter.SiteId = null;
      this.Sites = [];
    } else if (Combotype == 'Client') {
      this.Filter.ClientId = null;
      this.Filter.SiteId = null;
      this.Clients = [];
      this.Sites = [];
    }
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'UserType': 'A',
      'BranchId': this.Filter.BranchId,
      'ClientId': this.Filter.ClientId,
      'SiteId': this.Filter.SiteId,
      'EmpType': 'front',
      'EmpCode': this.Filter.EmpCode
    }).subscribe({
      next: (response) => {
        if (response.ComboLoad) {
          if (Combotype == 'Branch') {
            this.Branchs = response.ComboLoad;
          } else if (Combotype == 'Client') {
            this.Clients = response.ComboLoad;
          } else if (Combotype == 'Site') {
            this.Sites = response.ComboLoad;
          } else if (Combotype == 'EmpLoadForRegularization') {
            if (this.Filter.BranchId == null) {
              this.toast.show({ message: 'Kindly select atleast Branch', type: toastTypeEnum.warning });
              this.isDisabled = false;
              return;
            }
            if (response.ComboLoad.length == 0) {
              this.toast.show({ message: 'No data found', type: toastTypeEnum.warning });
              this.isDisabled = false;
              return;
            }
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.destroy();
              this.dtTrigger.next(null);
            });
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  addTermination(id: any){
    this.router.navigate(['/manualtermination/', id])
  }

}
